import * as yup from 'yup';
import { FaqList } from '@web/components';
import { linkSchema } from '../schemas';
import { schema as faqQuestionSchema } from './faq_question';

export const component = FaqList;

export const schema = yup
  .object({
    headline: yup.string().required(),
    subheadline: yup.string(),
    faqs: yup.array(faqQuestionSchema).required(),
    link: linkSchema,
    level: yup.string(),
    background_color: yup.string().nullable(),
    font_color: yup.string().nullable(),
  })
  .transform(value => ({
    ...value,
    link: value.link[0],
    level: value.level,
    backgroundColor: value.background_color,
    fontColor: value.font_color,
  }));
